import { AscImageSource, roundAndDropTrailingZeros } from "@ascendnow/shared";
import classNames from "classnames";
import AscAvatar from "../AscAvatar/AscAvatar";
import AscDropdown from "../AscDropdown/AscDropdown";
import AscLink from "../AscLink/AscLink";

import styles from "./AscUserDropdown.module.scss";
import AscModalClassic from "../AscModalClassic/AscModalClassic";
import { useState } from "react";

type AscDropdownAndOptionsWrapperPropsAlignment = "left" | "right";
export interface AscUserDropdownProps {
  avatarUrl?: AscImageSource;
  name?: string;
  globalRank?: number;
  classRank?: number;
  points?: number;
  globalRankLabel?: string;
  globalRankUrl?: string;
  classRankLabel?: string;
  classRankUrl?: string;
  pointsLabel?: string;
  children?: JSX.Element[];
  className?: string;
  alignment?: AscDropdownAndOptionsWrapperPropsAlignment;
  innerContainerClassName?: string;
  portalContentClassName?: string;
  nameClassName?: string;
  onLogout?: () => void;
  afterSelect?: () => void;
}

export default function AscUserDropdown({
  avatarUrl,
  name,
  globalRank,
  classRank,
  points,
  globalRankLabel = "Global Rank",
  classRankLabel = "School Rank",
  globalRankUrl,
  classRankUrl,
  pointsLabel = "Points",
  children = [],
  className,
  onLogout,
  alignment,
  innerContainerClassName,
  portalContentClassName,
  afterSelect,
  nameClassName,
}: AscUserDropdownProps) {
  const [confirmLogout, setConfirmLogout] = useState(false);
  const options = children?.concat(
    <AscDropdown.Option
      className={styles.separatedOption}
      onClick={() => setConfirmLogout(true)}
    >
      Logout
    </AscDropdown.Option>
  );

  return (
    <>
      <AscDropdown
        portalContentClassName={portalContentClassName}
        titleContainerClassName={innerContainerClassName}
        afterSelect={afterSelect}
        alignment={alignment}
        title={
          <div className={styles.nameAndAvatarContainer}>
            <AscAvatar src={avatarUrl} alt="User avatar" />
            <span className={classNames(styles.name, nameClassName)}>
              {name}
            </span>
            {/* <AscTag type="gold" label="Gold" /> */}
          </div>
        }
        optionItemClassName={styles.optionItem}
        optionContainerClassName={styles.optionContainer}
        header={
          <div className={styles.numbersContainer}>
            <AscLink
              // disabled={!!globalRankUrl}
              href={globalRankUrl || "#"}
              innerWrapperTag={null}
              className={styles.numberContainer}
            >
              <span className={classNames(styles.number, styles.globalRank)}>
                {globalRank}
              </span>
              <span className={classNames(styles.numberLabel)}>
                {globalRankLabel}
              </span>
            </AscLink>
            <AscLink
              // disabled={!!classRankUrl}
              href={classRankUrl || "#"}
              innerWrapperTag={null}
              className={styles.numberContainer}
            >
              <span className={classNames(styles.number, styles.classRank)}>
                {classRank}
              </span>
              <span className={classNames(styles.numberLabel)}>
                {classRankLabel}
              </span>
            </AscLink>
            <AscLink
              disabled
              innerWrapperTag={null}
              className={styles.numberContainer}
              href={"#"}
            >
              <span className={classNames(styles.number, styles.points)}>
                {roundAndDropTrailingZeros(points || 0)}
              </span>
              <span className={classNames(styles.numberLabel)}>
                {pointsLabel}
              </span>
            </AscLink>
          </div>
        }
        variant="secondary"
        className={classNames(className)}
      >
        {options}
      </AscDropdown>
      {confirmLogout && (
        <AscModalClassic
          visible={confirmLogout}
          setVisible={setConfirmLogout}
          icon="question-mark"
          type="cancel-and-confirm"
          title="Do you want to Log Out?"
          description="Are you sure that you want to Log Out?"
          confirmButtonAction={onLogout}
        />
      )}
    </>
  );
}
